import {PageType} from "../../../../enums/PageType";
import {getServerUrl} from "../../helpers/getServerUrl";
import queryString from "query-string";
import {history} from "../../../store";

export function getInitCase(transactionType, matchParams) {
    const { id } = matchParams;
    const { location } = history;
    const {
        action,
        type: originType,
        id: originId,
    } = queryString.parse(location.search, {arrayFormat: 'bracket'});

    // Case 1: New
    if (!id && !action) {
        return {
            transactionInitCase: PageType.new,
        };
    }

    // Case 2: Read
    if (!action) {
        return {
            transactionInitCase: PageType.view,
            id,
            originType: transactionType,
            url: `${getServerUrl(transactionType)}/${id}`,
        };
    }

    switch (action) {
        case 'pay':
            return {
                transactionInitCase: PageType.pay,
                id: originId,
                originType,
                url: `${getServerUrl(originType)}/${originId}`,
            };
        case 'duplicate':
            return {
                transactionInitCase: PageType.duplicate,
                id: originId,
                originType: transactionType,
                url: `${getServerUrl(transactionType)}/${originId}`,
            };
        case 'transfer':
            return {
                transactionInitCase: PageType.transfer,
                id: originId,
                originType,
                url: `${getServerUrl(originType)}/${originId}`,
            };
        case 'copy': {
            return {
                transactionInitCase: PageType.copy,
                id: originId,
                originType,
                url: `${getServerUrl(originType)}/${originId}`,
            };
        }
        case 'copy-items': {
            return {
                transactionInitCase: PageType.copy_items,
                id: originId,
                originType,
                url: `${getServerUrl(originType)}/${originId}`,
            };
        }
        default:
            throw new Error("Cannot proceed with transactionInit");
    }
}
